import React, {useEffect, useState} from 'react'
import {ArrowDownOnSquareIcon, XMarkIcon} from "@heroicons/react/24/solid";
import ShowDesignDetail from "../common/show-design-detail";
import ProductsDesigner from "./products-designer";
import {getAllDesignVariants, getBatchDesignVariants} from "../../services/design-variant-data-service";
import _ from "lodash";

const EditBatchDesignVariants = ({
                                     designDetail,
                                     setDesignDetail,
                                     batchDetail,
                                 }) => {
    const [showModal, setShowModal] = useState(false);
    const [saveDesignVariants, setSaveDesignVariants] = useState(false);
    const [designVariantList, setDesignVariantList] = useState(null);
    const [downloadAllImages, setDownloadAllImages] = useState(false);

    useEffect(() => {
        if (showModal) {
            getSelectedDesignVariantDetails();
        }

    }, [showModal]);

    const handleCloseAction = () => {
        setShowModal(false);
    }

    const getSelectedDesignVariantDetails = async () => {
        const designVariantListResult = await getBatchDesignVariants(designDetail?.id, batchDetail?.batchKey);
        setDesignVariantList(designVariantListResult);
    }

    const updateBatchDesignVariants = () => {
        setSaveDesignVariants(true);
    }

    return (
        <>
            <div className="">
                <button
                    className={`py-2 px-4 button-gray`}
                    onClick={() => setShowModal(true)}>
                    <span>Edit Batch Design Variants</span>
                </button>
            </div>

            {showModal ? (
                <>
                    <div
                        className="w-full h-full justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-x-0 top-0 z-50 outline-none focus:outline-none">
                        <div className="relative w-full h-full">
                            {/*content*/}
                            <div
                                className="border-0 shadow-lg relative flex flex-col w-full h-full bg-white outline-none focus:outline-none">
                                {/*header*/}
                                <div
                                    className="flex justify-between px-5 pt-4 rounded-t">
                                    <div className='flex justify-start items-center w-2/5'>
                                        <h3 className="text-2xl font-bold ml-2">Batch Design Variants Designer</h3>
                                    </div>

                                    <div className="w-full flex justify-start">
                                        <div>
                                            <ShowDesignDetail designDetail={designDetail}/>
                                        </div>
                                    </div>

                                    <div className="w-2/5 mr-2 flex justify-end items-center">
                                        <button onClick={() => {
                                            setDownloadAllImages(true);
                                        }}
                                                className="button-gray py-2 px-3 mr-2 flex justify-center">
                                            <div className="pr-2">
                                                <ArrowDownOnSquareIcon className="h-6 w-6"/>
                                            </div>
                                            Download All
                                        </button>
                                        <div className="mr-2 flex justify-start items-center">
                                            <button onClick={updateBatchDesignVariants}
                                                    className="button-green py-2 px-3 flex justify-center">
                                                Update Design Variants
                                            </button>
                                        </div>
                                        <div className="">
                                            <button
                                                className="button-gray-outline px-3 py-2"
                                                onClick={handleCloseAction}>
                                                <div className="">
                                                    <XMarkIcon className="h-6 w-6"/>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {/*body*/}
                                <div
                                    className="relative px-6">

                                    <div className="mt-4">
                                        {designVariantList &&
                                            <ProductsDesigner
                                                isBatchEdit={true}
                                                batchDetail={batchDetail}
                                                existingDesignDetail={designDetail}
                                                setExistingDesignDetail={setDesignDetail}
                                                containerCss={'batch-design-variants-designer-container'}
                                                setSaveDesignVariants={setSaveDesignVariants}
                                                saveDesignVariants={saveDesignVariants}
                                                designVariantList={designVariantList}
                                                setDesignVariantList={setDesignVariantList}
                                                showGrid={undefined}
                                                designsMap={undefined}
                                                setDesignsMap={undefined}
                                                processedImageList={undefined}
                                                parentProduct={undefined}
                                                setSelectedParentProduct={undefined}
                                                selectedParentProductList={undefined}
                                                downloadAllImages={downloadAllImages}
                                                setDownloadAllImages={setDownloadAllImages}/>
                                        }
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </>
    )
}

export default EditBatchDesignVariants
